import CompLayout from "@/pcomponents/comp/layout/layout";
import StudyListArea from "@/pages/comp/plan/study/study/common/list";
function ListPage() {
  
  return (
    <CompLayout isConTitle={false}>
      <StudyListArea></StudyListArea>
    </CompLayout>
  );
}

export default ListPage;